import _ from "lodash";
import {
  Component,
} from "react";
import {
  renderChildren,
  withLocation,
} from "CommonCore/router-util";
import {
  validate,
} from "uuid";
import {
  Alert,
  Button,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "react-bootstrap";
import apifetch from "CommonCore/apifetch";
import {
  getPathComponent,
  getPathPrefix,
  popAndReplaceComponent,
} from "CommonCore/location-util";
import store from "CommonState/store";
import antragApi, {
  antragParams,
  checkAntragZuständigkeitsWechsel,
  PREntscheidungOk,
  validateDokumente,
} from "Apis/antrag-api";
import uiconfig, {
  ifAllowed,
} from "CommonState/uiconfig";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  Spinner,
} from "CommonComponents/bricks";
import {
  updateStats,
} from "Components/db-widget-angaben";

import {
  ANTRAGSTATUS,
  GSB_PRUEFUNGEN,
  istArtTarifvertrag,
  istTypWerkvertrag,
  PR_ENTSCHEIDUNGEN,
  ROLLEN,
  ROLLEN_PR,
  ROLLEN_PRUEFVERMERK,
  SICHTBARKEIT,
  userSachb,
  userSachbErweitert,
  VERTRAGSARTEN_LEHRAUFTRAG,
  VERTRAGSARTEN_SHK,
  VERTRAGSARTEN_VORTRAG,
} from "App/constants";
import {
  validateTarif,
} from "Apis/antrag-tarifdaten-api";

import AntragStatuswechselPopup from "App/antrag-statuswechsel-popup";
import AntragEinreichenPopup from "App/antrag-einreichen-popup";
import AntragVertragPopup from "App/antrag-vertrag-popup";
import AntragExportierenPopup from "App/antrag-exportieren-popup";
import PersonValidierungPopup from "App/person-validierung-popup";
import AntragNotizenWidget from "App/antrag-notizen-widget";
import AntragProzessWidget from "App/antrag-prozess-widget";
import AntragTypÄndernPopup from "App/antrag-typ-aendern-popup";
import AntragStatuswechselValidierungPopup from "App/antrag-statuswechsel-validierung-popup";
import AntragAbbruchInfoPopup, {
  AntragAbbruchPopup,
} from "App/antrag-abbruch-info-popup";
import AntragAnpassenInfoPopup, {
  AntragAnpassenPopup,
} from "App/antrag-anpassen-info-popup";
import {
  AntragZuständigkeitOk,
} from "App/antrag-list-page";
import {
  validateMassnahme,
  validateVertrag,
} from "Apis/massnahme-api";
import Confirmation from "CommonComponents/confirmation";
import {
  getModus,
} from "App/antragsteller-modus";

const StatusWechselButtons = ({ onSelect, werte, style }) => {
  if (_.isEmpty(werte)) {
    return null;
  }

  return <DropdownButton
    variant='outline-primary'
    className='float-right' style={style} key='neu' title='Status wechseln' id='statuswechsel--button'
    onSelect={onSelect}>
    {werte && werte.map((st, i) => <Dropdown.Item key={i} eventKey={st.asf_id}>{`${ st.asf_kbez }`}</Dropdown.Item>)}
    {_.isEmpty(werte) && <div style={{ paddingLeft: 10 }}><h5>Keine möglich</h5></div>}
  </DropdownButton>;
};


@withLocation
@uiconfig
@ifAllowed("page.antrag")
@antragApi.list(antragParams())
@antragApi.uiList
@antragApi.current
@antragApi.actions
@store("user", "flag_angabenstatus", "flag_antragstellermodus", "k_pfaartLookup", "sy_pflichtanlageLookup", "k_pflichtanlageLookup")
export default class AntragVerwaltenPage extends Component {
  // Antragsübersicht und -Verwaltung
  constructor() {
    super();
    this.state = { werte: {} };
    this.popupEinreichen = 1;
    this.popupEinreichenOk = 2;
    this.popupVertrag = 3;
    this.popupValidierung = 4;
    this.popupPersonalnummerFehlt = 5;
    this.popupSuche = 6;
    this.popupZuständigkeit = 7;
    this.popupExport = 8;
    this.popupStatusNotiz = 9;
    this.popupTypÄndern = 10;
    this.popupAbbruchInfo = 11;
    this.popupAnpassenInfo = 12;
    this.popupAbbruch = 13;
    this.popupAnpassen = 14;
    this.popupExportLehrauftrag = 15;
    this.popupExportTarifvertrag = 16;
    this.popupStatuswechselValidierung = 17;
    this.popupAnpassen413 = 18;
  }

  getStatusWerte = async a_id => {
    if (a_id || a_id != "undefined") {
      this.setState({ werteInflight: true });
      const werte = await apifetch(`/api/shkantrag/antrag/moeglicherstatus/${ a_id }`);
      this.setState({ werte: { data: werte ? werte.data : [], antrag: a_id } });
      this.setState({ werteInflight: false });
    }
  };

  async componentDidUpdate(prevProps) {
    const a_id = getPathComponent(this.props.location, 2);
    const prev_a_id = getPathComponent(prevProps.location, 2);

    // Check if a_id changed or if we need to load initial data
    if (a_id !== prev_a_id || (!this.state.werte.antrag && a_id)) {
      if (!this.state.werteInflight && (!this.state.werte.antrag || this.state.werte.antrag !== a_id)) {
        await this.getStatusWerte(a_id);
      }
    }

    // Call getModus if props changed
    if (prevProps.flag_antragstellermodus !== this.props.flag_antragstellermodus) {
      await getModus(this.props);
    }
  }

  componentDidMount = async() => {
    const { user } = this.props;
    if (user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      await getModus(this.props);
      updateStats(this.props);
    }
  };

  render() {
    const { currentAntrag, currentAntragInflight, location, user } = this.props;
    const { popup, werte, errorMessage, statusWechselt } = this.state;
    const tab = getPathComponent(location, 3);
    const a_id = getPathComponent(location, 2);

    let crumbs = [];
    if (currentAntrag && currentAntrag.a_asid == ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN) {
      crumbs = [{
        name: "Verträge",
        path: "/vertrag",
      }, {
        name: `Vertrag ${ currentAntrag ? currentAntrag.a_nr : "" }`,
        path: getPathPrefix(location, 2),
      }];
    } else {
      crumbs = [{
        name: "Anträge",
        path: "/antrag",
      }, {
        name: `Antrag ${ currentAntrag ? currentAntrag.a_nr : "" }`,
        path: getPathPrefix(location, 2),
      }];
    }
    if (!currentAntrag || currentAntragInflight || !user) {
      return <Spinner />;
    }

    const istAntragsteller = (user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER);
    const istSachb = userSachb(user);
    const istDekan = (user.ro_id == ROLLEN.ROLLE_DEKANAT);
    const istProfessor = (user.ro_id == ROLLEN.ROLLE_PROFESSOR);
    const istDekanOderProfessor = istDekan || istProfessor;
    const istVerwaltung = ([ROLLEN.ROLLE_GLEICHSTELLUNG, ...ROLLEN_PR].indexOf(user.ro_id) >= 0);
    const istPersonalrat = (ROLLEN_PR.indexOf(user.ro_id) >= 0);
    const istPersonalleitung = (user.ro_id === ROLLEN.ROLLE_PERSONALLEITUNG);
    const istSachgebietsleitung = (user.ro_id === ROLLEN.ROLLE_SACHGEBIETSLEITUNG);
    const sbvUndGsb = ([ROLLEN.ROLLE_GLEICHSTELLUNG, ROLLEN.ROLLE_SBV].indexOf(user.ro_id) >= 0);
    const istSbv = (user.ro_id === ROLLEN.ROLLE_SBV);
    const istNeu = currentAntrag && currentAntrag.a_asid == ANTRAGSTATUS.STATUS_NEU;
    const kannEinreichen = istAntragsteller && currentAntrag && [ANTRAGSTATUS.STATUS_NEU, ANTRAGSTATUS.STATUS_UEBERARBEITEN].indexOf(currentAntrag.a_asid) >= 0;
    const kannVertrag = istSachb && currentAntrag && [ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ERSTELLEN, ANTRAGSTATUS.STATUS_VERTRAGSUNTERLAGEN_UNVOLLSTAENDIG].indexOf(currentAntrag.a_asid) >= 0;

    const istWerkvertrag = currentAntrag && istTypWerkvertrag(currentAntrag.a_katid);
    const istLehrauftrag = currentAntrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;
    const istTarifvertrag = currentAntrag && istArtTarifvertrag(currentAntrag.a_artid);
    const istVortrag = currentAntrag && VERTRAGSARTEN_VORTRAG.indexOf(currentAntrag.a_artid) >= 0;

    const kannZuständigkeit = userSachbErweitert(user) && checkAntragZuständigkeitsWechsel(currentAntrag, user);

    const istSachb11_13 = (user.ro_id == ROLLEN.ROLLE_DEZ1_3 || user.ro_id == ROLLEN.ROLLE_DEZ1_1 || user.ro_id == ROLLEN.ROLLE_AUSSENWIRTSCHAFT);

    const layout = { main: 8, sidebar: 4 };

    // Liste aller möglichen Tabs
    const allTabs = [
      { key: "antragsteller", item: <NavItem key='antragsteller'><NavLink eventKey='antragsteller'>Person</NavLink></NavItem> },
      { key: "stamm", item: <NavItem key='stamm'><NavLink eventKey='stamm'>Person</NavLink></NavItem> },
      {
        key: "studium",
        item:
          <NavItem key='studium'>
            <NavLink eventKey='studium'>{istTarifvertrag ? "Ausbildung" : istLehrauftrag ? "Qualifikation" : "Studium"}</NavLink>
          </NavItem>,
      },
      {
        key: "weiterebv",
        item: <NavItem key='weiterebv'><NavLink eventKey='weiterebv'>
          {istLehrauftrag ? "Weitere LV" : `${ !istTarifvertrag ? "Weitere " : "" }BV`}
        </NavLink></NavItem>,
      },
      {
        key: "weiterebv_ast",
        item: <NavItem key='weiterebv_ast'><NavLink eventKey='weiterebv'>
          {istLehrauftrag ? "Weitere Lehraufträge" : `${ !istTarifvertrag ? "Weitere " : "" }Beschäftigungsverhältnisse`}
        </NavLink></NavItem>,
      }, // nur anderer Titel
      { key: "steuer", item: <NavItem key='steuer'><NavLink eventKey='steuer'>LBV Person  </NavLink></NavItem> },
      { key: "status", item: <NavItem key='status'><NavLink eventKey='status'>LBV Status</NavLink></NavItem> },
      { key: "anlagen", item: <NavItem key='anlagen'><NavLink eventKey='anlagen'>Anlagen</NavLink></NavItem> },
      { key: "tarif", item: <NavItem key='tarif'><NavLink eventKey='tarif'>Tarifdaten</NavLink></NavItem> },
      { key: "dokumente_sb", item: <NavItem key='dokumente_sb'><NavLink eventKey='dokumente_sb'>Dokumente SB</NavLink></NavItem> },
      { key: "personalrat", item: <NavItem key='personalrat'><NavLink eventKey='personalrat'>Entscheidung PR</NavLink></NavItem> },
      { key: "pruefvermerk", item: <NavItem key='pruefvermerk'><NavLink eventKey='pruefvermerk'>Prüfvermerk</NavLink></NavItem> },
      { key: "vertraege", item: <NavItem key='vertraege'><NavLink eventKey='vertraege'>Arbeitszeiten</NavLink></NavItem> },
      { key: "historie", item: <NavItem key='historie'><NavLink eventKey='historie'>Historie</NavLink></NavItem> },
    ];

    // Modusinfo (erweiterbar) zusammenfassen
    const modusInfo = { istWerkvertrag, istLehrauftrag, istTarifvertrag, istVortrag };

    // Tabs je Rolle filtern
    let rollenliste = [];
    let filteredTabs = [];

    if (istAntragsteller) {
      if (currentAntrag.a_asid != ANTRAGSTATUS.STATUS_UEBERARBEITEN) {
        // Persönlichen Daten in diesem Zustand für Antragsteller anzeigen
        rollenliste = ["antragsteller", "weiterebv_ast", "anlagen"];
      } else {
        rollenliste = ["anlagen"];
      }
    } else {
      // Uni-Rollen
      if (istSachb) {
        rollenliste = ["stamm", "studium", "steuer", "status", "weiterebv", "anlagen", "historie", "vertraege"];
      } else if (istSachb11_13) {
        rollenliste = ["stamm", "studium", "steuer", "status", "weiterebv", "anlagen", "historie", "vertraege"];
      } else if (istVerwaltung) {
        rollenliste = ["stamm", "studium", "weiterebv", "historie"];
      } else if (istSbv) {
        rollenliste = ["stamm", "studium", "weiterebv", "historie"];
      } else if (istDekan) {
        rollenliste = ["stamm", "studium", "weiterebv", "anlagen", "historie"];
      } else if (istPersonalleitung) {
        rollenliste = ["stamm", "studium", "steuer", "status", "weiterebv", "anlagen", "historie", "vertraege"];
      } else if (istSachgebietsleitung) {
        rollenliste = ["stamm", "studium", "steuer", "status", "weiterebv", "anlagen", "historie", "vertraege"];
      }

      if (istTarifvertrag) {
        if (!sbvUndGsb && !istDekanOderProfessor) { // PBP-2305 nicht für SBV/GSB sowie Dekanat/Professor
          rollenliste.push("personalrat"); // PBP-2271 für alle Uni-Rollen (readonly für alle außer PR)
        }
        if (istSachb || istPersonalrat || sbvUndGsb || istPersonalleitung || istSachgebietsleitung) {
          rollenliste.push("tarif"); // PBP-2241 Tarif tab für Dez 4 Sachbearbeitung und Personalrat (readonly für PR)
          rollenliste.push("dokumente_sb");
        }
      }
    }
    if (ROLLEN_PRUEFVERMERK.indexOf(user.ro_id) >= 0) {
      rollenliste.push("pruefvermerk");
    }
    filteredTabs = _.filter(allTabs, item => rollenliste.indexOf(item.key) >= 0);

    // Tabs je Antragstyp filtern
    if (istWerkvertrag) {
      // Werkvertrag bekommt weniger Reiter
      const negativliste = ["steuer", "studium", "status", "weiterebv", "weiterebv_ast"];
      filteredTabs = _.filter(filteredTabs, item => negativliste.indexOf(item.key) < 0);
    }

    if (istLehrauftrag) {
      // Lehrauftrag bekommt weniger Reiter
      const negativliste = ["steuer", "status", "weiterebv", "weiterebv_ast"];
      filteredTabs = _.filter(filteredTabs, item => negativliste.indexOf(item.key) < 0);
    }

    if (istDekanOderProfessor) {
      filteredTabs = _.filter(filteredTabs, item => ["anlagen", "personalrat"].indexOf(item.key) < 0);
    }

    if (istVortrag) {
      // Vortrag/Kolloquium bekommt nur den Reiter "Person" (und ggf. "Prüfvermerk")
      const positivliste = ["stamm", "antragsteller", "pruefvermerk"];
      filteredTabs = _.filter(filteredTabs, item => positivliste.indexOf(item.key) >= 0);
    }

    // Popups
    const getPopup = id => {
      const a_id = getPathComponent(this.props.location, 2);

      switch (id) {
        case this.popupEinreichen: return <AntragEinreichenPopup modus={modusInfo} a_id={a_id} onClose={this.finishEinreichen} onCancel={this.clearPopup} />;
        case this.popupEinreichenOk: return <AntragEinreichenOkPopup modus={modusInfo} a_id={a_id} onClose={this.afterEinreichenOk} />;
        case this.popupVertrag: return <AntragVertragPopup antrag={currentAntrag} onCancel={() => this.clearPopup()} a_id={a_id} sachb={istSachb} onClose={this.finishVertrag} />;
        case this.popupValidierung: return <PersonValidierungPopup onClose={this.finishValidierung} />;
        case this.popupPersonalnummerFehlt: return <NummerFehltPopup onClose={() => {
          this.clearPopup(); this.navigate("stamm");
        }} />;
        case this.popupZuständigkeit: return <AntragZuständigkeitOk item={currentAntrag} onClose={this.finishZuständigkeit} />;
        case this.popupExport: return <AntragExportierenPopup antrag={currentAntrag} onClose={this.finishExport} onCancel={() => this.clearPopup()} />;
        case this.popupExportLehrauftrag: return <AntragExportierenPopup antrag={currentAntrag} onClose={this.finishExportLehrauftrag} onCancel={() => this.clearPopup()} />;
        case this.popupExportTarifvertrag: return <AntragExportierenPopup antrag={currentAntrag} onClose={this.finishExportTarifvertrag} onCancel={() => this.clearPopup()} />;
        case this.popupStatusNotiz: return <AntragStatuswechselPopup a_id={a_id} zielstatus={this.state.zielstatus} onClose={this.finishStatuswechsel} onCancel={this.clearPopup} />;
        case this.popupTypÄndern: return <AntragTypÄndernPopup a_id={a_id} onClose={this.finishTypÄndern} onCancel={() => this.clearPopup()} />;

        case this.popupAbbruch: return <AntragAbbruchPopup antrag={currentAntrag} onConfirm={this.handleConfirmAbbruch} onCancel={() => this.clearPopup()} />;
        case this.popupAbbruchInfo: return <AntragAbbruchInfoPopup antrag={currentAntrag} onConfirm={() => {
          this.clearPopup(); this.props.history.push("/antrag");
        }} />;

        case this.popupAnpassen: return <AntragAnpassenPopup antrag={currentAntrag} onConfirm={this.handleConfirmAnpassen} onCancel={() => this.clearPopup()} />;
        case this.popupAnpassen413: return <AntragAnpassenPopup antrag={currentAntrag} onConfirm={this.handleConfirmAnpassen413} onCancel={() => this.clearPopup()} />;
        case this.popupAnpassenInfo: return <AntragAnpassenInfoPopup antrag={currentAntrag} onConfirm={() => {
          this.clearPopup(); this.props.history.push("/antrag");
        }} />;
        case this.popupStatusWechselValidierung: return <AntragStatuswechselValidierungPopup errorMessage={this.state.errorMessage} antrag={currentAntrag} onClose={() => this.clearPopup()} />;
      }
    };

    const unvollstaendig = currentAntrag.a_asid == ANTRAGSTATUS.STATUS_VERTRAGSUNTERLAGEN_UNVOLLSTAENDIG;

    return <div>
      <Breadcrumb data={crumbs} />

      <Container fluid>
        <Row>
          <Col md={layout.main}>
            <Container fluid style={{ marginRight: 15 }}>
              <Row>
                {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
                <Nav variant='tabs' activeKey={tab} onSelect={this.navigate} id='ue-tabs'>
                  <NavItem><NavLink eventKey='deckblatt'>Antrag</NavLink></NavItem>

                  {_.map(filteredTabs, x => x.item)}
                  <span className='ml-auto'>
                    {kannEinreichen && <NavItem><Button variant='primary' style={{ marginTop: "2px", marginRight: "2px" }} onClick={this.startEinreichen}>Prüfen / Antrag einreichen</Button></NavItem>}
                    {kannVertrag && <NavItem><Button variant='primary' style={{ marginTop: "2px", marginRight: "2px" }} onClick={this.startVertrag}>{istSachb ? `Vertrag ${ unvollstaendig ? "erneut " : "" }eingereicht` : `Prüfen / ${ istWerkvertrag ? "Vertrag" : "Arbeitsvertrag" } einreichen`}</Button></NavItem>}

                    {kannZuständigkeit && <NavItem><Button variant='outline-primary' style={{ marginTop: "2px", marginRight: "2px" }} onClick={this.startZuständigkeit}>Zuständigkeit übernehmen</Button></NavItem>}

                    {!istAntragsteller && <NavItem><StatusWechselButtons style={{ marginTop: "2px", marginRight: "2px" }} onSelect={this.statusWechseln} a_id={a_id} werte={werte.data} /></NavItem>}

                    {istAntragsteller && !istWerkvertrag && !istVortrag && istNeu && <NavItem><Button variant='primary' style={{ marginTop: "2px", marginRight: "2px" }} onClick={this.startTypÄndern}>Typ ändern</Button></NavItem>}
                  </span>

                  {popup && getPopup(popup)}
                  {statusWechselt && <Spinner />}
                </Nav>

              </Row>
              <Row className='tab'>
                {renderChildren(this.props)}
              </Row>
            </Container>
          </Col>
          {(currentAntrag && layout.sidebar > 0) &&
            <Col md={layout.sidebar}>
              {istAntragsteller && <Row><AntragProzessWidget /></Row>}
              <Row>
                <AntragNotizenWidget antrag={currentAntrag} readonly={false} rolle={user.ro_id} ast={istAntragsteller} />
              </Row>
            </Col>
          }
        </Row>
      </Container>
    </div>;
  }

  handleConfirmAbbruch = () => {
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_ANTRAG_ABGEBROCHEN);
  };

  handleConfirmAnpassen = () => {
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH);
  };
  handleConfirmAnpassen413 = () => {
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH_413);
  };


  navigate = eventKey => {
    const { history, location } = this.props;
    // verhindern, dass bei Auswahl von Select auch navigiert wird
    if (!validate(eventKey)) {
      this.setState({ errorMessage: null });
      history.push(popAndReplaceComponent(location, 3, eventKey));
    }
  };

  clearPopup = callBack => {
    this.setState({ popup: null, errorMessage: null }, callBack);
  };
  setPopup = (id, zielstatus, errorMessage) => {
    this.setState({ popup: id, zielstatus, errorMessage });
  };

  finishExport = () => {
    // Export mit Statuswechsel abschließen
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN);
  };

  finishExportLehrauftrag = () => {
    // Export mit Statuswechsel abschließen (Lehrauftrag)
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN);
  };

  finishExportTarifvertrag = () => {
    // Export mit Statuswechsel abschließen (Tarifvertrag)
    this.clearPopup();
    this.statusWechseln(null, null, true, ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN);
  };


  finishStatuswechsel = async grund => {
    // Notiz am Antrag speichern und Statuswechsel durchführen
    const { currentAntrag: a, user } = this.props;
    const { zielstatus } = this.state;

    this.clearPopup();
    const sichtbar = user.ro_id === ROLLEN.ROLLE_SBV ? SICHTBARKEIT.SICHTBAR_FÜR_ROLLE_SBV_PA_PR : SICHTBARKEIT.SICHTBAR_FÜR_ROLLE_UND_PA;
    const notiz = { no_aid: a.a_id, no_nid: user.n_id, no_text: grund, no_ksiid: sichtbar };

    try {
      await apifetch(`/api/shkantrag/notiz`, { method: "POST", body: notiz });
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Notiz konnte nicht angelegt werden.",
      });
      return false;
    }

    this.statusWechseln(zielstatus.asf_id, null, true);
  };

  statusWechseln = async(eventKey, event, deferTriggers, zst = null) => {
    // Statuswechsel auslösen
    const { location, currentAntrag, user } = this.props;
    const { werte } = this.state;
    const a_id = getPathComponent(location, 2);
    const zielstatus = werte.data.find(x => eventKey ? (x.asf_id == eventKey) : (x.asf_zasid == zst));
    const zStatus = zielstatus.asf_zasid;

    const istPersonalrat = (ROLLEN_PR.indexOf(user.ro_id) >= 0);
    const istTarif = istArtTarifvertrag(currentAntrag.a_artid);
    const istHilfskraft = VERTRAGSARTEN_SHK.includes(currentAntrag.a_artid);

    if (!deferTriggers) {
      if (zStatus == ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ERSTELLEN &&
        istHilfskraft &&
        currentAntrag.massnahmen[0].m_bvorbehalt === true
      ) {
        const text = "Durch Bewilligungsvorbehalt ist der Statuswechsel auf Dienstvertrag erstellen nicht möglich.";
        this.setPopup(this.popupStatusWechselValidierung, null, text);
        return false;
      }
      if (zStatus == ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN ||
        zStatus == ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN ||
        zStatus == ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN
      ) {
        // Prüfen ob es einen Bewilligungsvorbehalt gibt, dann kein SVA-Export.
        if (currentAntrag.massnahmen[0].m_bvorbehalt === true) {
          const text = "Durch Bewilligungsvorbehalt ist das Abschliessen des Antrags nicht möglich.";
          this.setPopup(this.popupStatusWechselValidierung, null, text);
          return false;
        }

        /*
         * Export nach SVA versuchen
         * Personalnummer muss gefüllt sein
         */
        if (!currentAntrag.antrag_person[0].ap_svakey) {
          this.setPopup(this.popupPersonalnummerFehlt);
          return false;
        }
        if (zStatus == ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN) {
          this.setPopup(this.popupExportLehrauftrag);
        } else if (zStatus == ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN) {
          this.setPopup(this.popupExportTarifvertrag);
        } else {
          this.setPopup(this.popupExport);
        }
        return false;
      } else if (zStatus == ANTRAGSTATUS.STATUS_ANTRAG_ABGEBROCHEN) {
        // Bei Abbruch nachfragen
        this.setPopup(this.popupAbbruch);
        return false;
      } else if (zStatus == ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH) {
        // Bei Anpassen nachfragen
        this.setPopup(this.popupAnpassen);
        return false;
      } else if (zStatus == ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH_413) {
        // Bei Anpassen nachfragen
        this.setPopup(this.popupAnpassen413);
        return false;
      } else if (zielstatus.brauchtNotiz) {
        // Popup für Sicherheitsabfrage und Notiz vorschalten
        this.setPopup(this.popupStatusNotiz, zielstatus);
        return false; // Statuswechsel geht nach Popup weiter
      } else if (istPersonalrat && PR_ENTSCHEIDUNGEN.includes(zStatus)) {
        // Personalratsentscheidung lesen
        if (!await PREntscheidungOk(currentAntrag.a_id)) {
          const text = "Die Entscheidung des Personalrats ist noch nicht dokumentiert.";
          this.setPopup(this.popupStatusWechselValidierung, null, text);
          return false;
        }
      } else if (istTarif && GSB_PRUEFUNGEN.includes(zStatus)) {
        // Tariftab validieren
        const tarifdaten = await apifetch(`/api/shkantrag/tarif/${ currentAntrag.a_id }`);

        if (!tarifdaten || validateTarif(tarifdaten, currentAntrag)) {
          const text = "Bitte füllen Sie zunächst die Tarifdaten vollständig aus.";
          this.setPopup(this.popupStatusWechselValidierung, null, text);
          return false;
        }
      }
    }

    try {
      this.setState({ statusWechselt: true });
      const { hatRollenwechsel } = await apifetch("/api/shkantrag/antrag/statuswechsel", {
        method: "POST",
        body: {
          a_id: a_id,
          asf_id: zielstatus.asf_id,
        },
      });

      if (zStatus == ANTRAGSTATUS.STATUS_ANTRAG_ABGEBROCHEN) {
        // Info zum Abbruch in PBP anzeigen
        this.setPopup(this.popupAbbruchInfo);
      } else if (zStatus == ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH || zStatus == ANTRAGSTATUS.STATUS_ÄNDERUNG_ERFORDERLICH_413) {
        // Info zum Anpassen in PBP anzeigen
        this.setPopup(this.popupAnpassenInfo);
      } else {
        // Zur Antragsliste wechseln, wenn sich die Rollenzuständigkeit geändert hat
        if (hatRollenwechsel) {
          this.props.history.push(`/antrag`);
        } else {
          // Antrag neuladen
          await this.props.refreshAntragInStore(a_id);
          await this.getStatusWerte(a_id);
        }
      }

      this.setState({ statusWechselt: false, errorMessage: "" });
    } catch(err) {
      this.setState({
        statusWechsel: false,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };

  startEinreichen = async() => {
    // Splashscreen zum Einreichen einblenden

    let { flag_angabenstatus } = _.cloneDeep(this.props);
    const { currentAntrag, user } = _.cloneDeep(this.props);
    if (!flag_angabenstatus) {
      flag_angabenstatus = await updateStats(this.props);
    }
    const istLehrauftrag = currentAntrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;
    const istTarifvertrag = istArtTarifvertrag(currentAntrag.a_artid);
    const validierungsFehler = _.some(Object.keys(flag_angabenstatus), gruppe => !_.isEmpty(flag_angabenstatus[gruppe]));
    if (validierungsFehler) {
      // Formularinhalte fehlerhaft
      this.setPopup(this.popupValidierung);
    } else {
      // Daten ok, Maßnahmen des Antrages validieren
      if (_.isEmpty(currentAntrag.a_eingangsdat) || currentAntrag.a_asid === ANTRAGSTATUS.STATUS_UEBERARBEITEN) {
        const statusValidate = [];
        _.map(currentAntrag.massnahmen, (m, index) => {
          const status = validateMassnahme(user, m);
          if (status) {
            status.nachricht = `Maßnahme ${ index + 1 }: ${ status.nachricht }`;
            statusValidate.push(status);
          }
        });
        if (!_.isEmpty(statusValidate)) {
          this.setState({ errorMessage: statusValidate[0].nachricht });
          return false;
        }
          // Maßnahmen ok, Dokumente prüfen
        const status = await validateDokumente(user, currentAntrag, this.props);
        if (status) {
          this.setState({ errorMessage: status });
          return false;
        }
            // Dokumente ok, Vertragsarten prüfen
        if (!istTypWerkvertrag(currentAntrag.a_katid) && !istLehrauftrag && !istTarifvertrag) {
          const statusArten = [];
          const result = await validateVertrag(currentAntrag.massnahmen, this.state, this.props); // Props wg. Lookups übergeben
          _.map(result, record => {
            statusArten.push({ nachricht: `Maßnahme ${ record.index + 1 }: ${ record.text }` });
          });
          if (!_.isEmpty(statusArten)) {
            this.setState({ errorMessage: statusArten[0].nachricht });
            return false;
          }
        }
      }
      this.setPopup(this.popupEinreichen);
    }
  };

  startVertrag = () => {
    // Splashscreen zum Einsenden des Vertrages einblenden
    this.setPopup(this.popupVertrag);
  };

  startTypÄndern = () => {
    // Splashscreen zum Ändern des Antragstyps einblenden
    this.setPopup(this.popupTypÄndern);
  };
  finishTypÄndern = async() => {
    // ... Dinge
    this.clearPopup();
    const { currentAntrag } = this.props;
    await this.props.refreshAntragInStore(currentAntrag.a_id);
    await this.getStatusWerte(currentAntrag.a_id);
  };

  finishValidierung = route => {
    // Validierungspopup wird geschlossen, ggf. zu Route navigieren
    this.clearPopup();
    if (route) {
      // Geschlossen mit Klick auf Link
      this.props.history.push("/");
      this.props.history.push(route);
    }
  };

  finishEinreichen = () => {
    this.setPopup(this.popupEinreichenOk);
  };
  afterEinreichenOk = () => {
    this.clearPopup();
    this.props.history.push(`/antrag`);
  };
  finishVertrag = () => {
    this.clearPopup;
    this.props.history.push(`/antrag`);
  };
  startZuständigkeit = () => {
    this.setPopup(this.popupZuständigkeit); // Hint: Popup geht für SB nicht auf, sondern macht nur das Update
  };
  finishZuständigkeit = () => {
    const { currentAntrag } = this.props;
    this.clearPopup();
    currentAntrag.a_sb_nid = this.props.user.n_id;
    this.props.saveAntrag(currentAntrag);
  };

  afterPersonalnummer = async() => {
    // Suche durchgeführt und Personalnummer ggf. gesetzt
    const { currentAntrag } = this.props;
    await this.props.refreshAntragInStore(currentAntrag.a_id);
    this.clearPopup();
    this.forceUpdate();
  };
}

export class AntragEinreichenOkPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const { modus } = this.props;

    let body;

    if (modus.istWerkvertrag) {
      body = <span><h3>Ihr Antrag wurde eingereicht</h3>
        <p>Sie haben Ihren Antrag nun zur Prüfung an das Dezernat 1 weitergeleitet. Die Prüfung nimmt in der Regel 4 Wochen Zeit in Anspruch.</p>
        <p>Nach Abschluss der Antragsprüfung werden Sie per E-Mail informiert. Danach müssen Sie hier im System Ihren Werkvertrag herunterladen und ausdrucken. Anlagen, die Sie außerdem beifügen müssen, werden Ihnen auch an dieser Stelle genannt.</p>
        <p>Sofern der Antrag von Ihnen überarbeitet werden muss, werden Sie darüber ebenfalls per Mail informiert.</p>
      </span>;
    } else if (modus.istLehrauftrag) {
      body = <span><h3>Ihr Antrag wurde eingereicht</h3>
        <p>Sie haben Ihren Antrag nun zur Prüfung an das Personaldezernat Hilfskräfte und Lehraufträge weitergeleitet. Die Prüfung nimmt in der Regel 2-4 Wochen Zeit in Anspruch.</p>
        <p>Nach Abschluss der Antragsprüfung werden Sie per E-Mail informiert.</p>
        <p>Sofern der Antrag von Ihnen überarbeitet werden muss, werden Sie darüber ebenfalls per Mail informiert.</p>
      </span>;
    } else if (modus.istTarifvertrag) {
      body = <span><h3>Antrag wurde eingereicht</h3>
        <p>Sie haben den Antrag zur Prüfung an das Personaldezernat weitergeleitet. Die Prüfung nimmt in der Regel 2-4 Wochen Zeit in Anspruch.</p>
        <p>Nach Abschluss der Antragsprüfung nimmt das Personaldezernat Kontakt zu Ihnen auf, um einen Termin zur Unterzeichnung des Arbeitsvertrags zu vereinbaren.</p>
        <p>Sofern der Antrag von Ihnen überarbeitet werden muss, werden Sie per E-Mail darüber informiert.</p>
        <p>Sie haben nun die Möglichkeit, sich unter „Anlagen“ die für den Arbeitsvertrag erforderlichen Dokumente anzuschauen.</p>
      </span>;
    } else if (modus.istVortrag) {
      body = <span><h3>Ihr Antrag wurde eingereicht</h3>
        <p>Sie haben Ihren Antrag nun zur Prüfung an die zentrale Vergabestelle weitergeleitet. Die Prüfung nimmt ca. 2 Wochen Zeit in Anspruch.<br />Nach Abschluss der Antragsprüfung oder sofern der Antrag von Ihnen überarbeitet werden muss, werden Sie per E-Mail informiert.</p>
      </span>;
    } else {
      body = <span><h3>Ihr Antrag wurde eingereicht</h3>
        <p>Sie haben Ihren Antrag nun zur Prüfung an das Personaldezernat Hilfskräfte und Lehraufträge weitergeleitet. Die Prüfung nimmt in der Regel 2-4 Wochen Zeit in Anspruch.</p>
        <p>Nach Abschluss der Antragsprüfung werden Sie per E-Mail informiert. Danach müssen Sie hier im System Ihren Dienstvertag sowie alle weiteren erforderlichen Anlagen herunterladen und ausdrucken. Anlagen, die Sie außerdem in Kopie beifügen müssen, werden Ihnen auch an dieser Stelle genannt.</p>
        <p>Sofern der Antrag von Ihnen überarbeitet werden muss, werden Sie ebenfalls per E-Mail darüber informiert.</p></span>;
    }

    return (
      <Confirmation
        header='Antrag eingereicht'
        action='Ok'
        actionStyle='primary'
        onConfirm={this.onConfirm}
      >
        {body}
      </Confirmation>
    );
  }
  onConfirm = () => {
    this.props.onClose();
  };
}

export class NummerFehltPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
      <Confirmation
        header='Personalnummer fehlt'
        action='Ok'
        actionStyle='primary'
        onConfirm={this.onConfirm}
      >
        <p>Um die Daten an SVA übertragen zu können, muss dem Antrag eine gültige Personalnummer zugeordnet sein</p>
        <p>Auf Reiter 'Person' können Sie über eine Schaltfläche Personen in SVA suchen und neu anlegen um die Personalnummer zu setzen.</p>
      </Confirmation>
    );
  }
  onConfirm = () => {
    this.props.onClose();
  };
}
